import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import Button from 'button-component';
import Icon from 'icon-component';
import {setNewData} from '../../common/search-actions';

const defaultSubtitle = 'Reserve your parking through SpotHero, save up to 50%, and get everywhere, easier.';
const renderPrevious = (searchType, currentPage, setNewSearchData) => {
    if ((searchType === 'event' && currentPage === 'events')
        || currentPage === 'map'
        || currentPage === 'search') {
            return null;
    }

    return (
        <div className="SH-Navigation-previous">
            <Button
                className="SH-Navigation-previous-btn"
                onClick={() => {
                    setNewSearchData({
                        data: {
                            currentPage: (searchType === 'event') ? 'events' : 'map'
                        }
                    });
                }}
            >
                <Icon name="chevron-left" />
            </Button>
        </div>
    );
};

const Navigation = ({
    searchType,
    title,
    subtitle,
    showDefaultSubtitle,
    unbranded,
    showMapLink,
    currentPage,
    setNewSearchData,
    onLogoClick,
    container
}) => {
    const classes = classNames(
        'SH-Navigation',
        {'SH-Navigation-search': currentPage === 'map'},
        {'SH-Navigation-unbranded': unbranded}
    );

    return (
        <div className={classes}>
            {renderPrevious(searchType, currentPage, setNewSearchData)}
            {!unbranded &&
                <div className="SH-Navigation-main">
                    <div className="SH-Navigation-main-content">
                        <Button className="SH-Navigation-logo" onClick={onLogoClick}>
                            <Icon name="spothero" />
                        </Button>
                        <div className="SH-Navigation-info">
                            <div className="SH-Navigation-title">{title}</div>
                            {((subtitle !== defaultSubtitle) || (subtitle === defaultSubtitle && showDefaultSubtitle)) &&
                                <div className="SH-Navigation-subtitle">{subtitle}</div>
                            }
                        </div>
                    </div>
                </div>
            }
            {showMapLink && (container.offsetWidth < 750) && currentPage !== 'map' &&
                <Button
                    className="SH-Navigation-map-link"
                    onClick={() => {
                        setNewSearchData({
                            data: {
                                currentPage: 'map',
                                showMapLink: false
                            }
                        });
                    }}
                >
                    Map
                </Button>
            }
        </div>
    );
};

Navigation.propTypes = {
    searchType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    showDefaultSubtitle: PropTypes.bool,
    unbranded: PropTypes.bool,
    showMapLink: PropTypes.bool,
    currentPage: PropTypes.string.isRequired,
    setNewSearchData: PropTypes.func.isRequired,
    onLogoClick: PropTypes.func.isRequired,
    container: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
};

Navigation.defaultProps = {
    title: 'SpotHero Parking',
    subtitle: defaultSubtitle
};

const mapStateToProps = state => {
    const {
        search: {
            data: {
                searchType,
                currentPage,
                showMapLink
            }
        }
    } = state;

    return {
        searchType,
        currentPage,
        showMapLink
    };
};

const mapDispatchToProps = {
    setNewSearchData: setNewData
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./widget/src/js/components/navigation/Navigation.jsx